import * as Cookies from 'js-cookie'

import { sanitizeParameter } from '../urlUtilities'

export const sanitizeCookie = (cookieName) => {
  return sanitizeParameter(Cookies.get(cookieName))
}
